import React, { Component } from 'react';
import './scss/style.css';
import { Main } from './components';

class App extends Component {

  playerBlackUser = {
    isAI:false,
    getNextCell(state){
      let e = state.items.black.placeableCells.length-1;
      return state.items.black.placeableCells[e];
    }
  };

  playerWhiteUser = {
    isAI:true,
    getNextCell(state){
      let e = state.items.white.placeableCells.length-1;
      return state.items.white.placeableCells[e];
    }
  };

  render() {
    return (
      <div className="App">
        {/* <Main playerBlack={this.playerBlackUser} playerWhite={this.playerWhiteUser}></Main> */}
        <Main></Main>
      </div>
    );
  }
}

export default App;
